import { gql } from 'graphql-request'

export const RECETAS_FIELDS_FRAGMENT = gql`
  fragment RecetaFieldsFragment on Receta {
    _id
    numeroReceta
    nombreReceta
    descripcion
    rendimiento
    sucursal {
      codigo
      direccion
    }
    tiempoEstimado
    nota
    instrucciones
    insumos {
      cantidad
      articuloUnidadMedida {
        _id
        codigoUnidadMedida
        nombreUnidadMedida
      }
      articulo {
        _id
        codigoArticulo
        nombreArticulo
      }
      detalleExtra
    }
    producto {
      cantidad
      articuloUnidadMedida {
        _id
        codigoUnidadMedida
        nombreUnidadMedida
      }
      articulo {
        _id
        codigoArticulo
        nombreArticulo
      }
      detalleExtra
    }
    productosAdicionales {
      cantidad
      articuloUnidadMedida {
        _id
        codigoUnidadMedida
        nombreUnidadMedida
      }
      articulo {
        _id
        codigoArticulo
        nombreArticulo
      }
      detalleExtra
    }
    usucre
    usumod
    createdAt
    updatedAt
  }
`
